import React from 'react';
import { getPurchaseOrderProgressPercent } from '../../utils/purchaseOrderProgress';

/**
 * Barra de avance de recepción / documentación de una orden de compra.
 */
const PurchaseOrderProgressBar = ({
  order,
  percent: percentProp,
  className = '',
  showPercent = true,
  barClassName = 'h-2',
}) => {
  const percent = percentProp ?? getPurchaseOrderProgressPercent(order);

  return (
    <div className={`flex items-center gap-2 min-w-0 ${className}`}>
      <div className={`flex-1 min-w-[4rem] bg-gray-200 rounded-full overflow-hidden ${barClassName}`}>
        <div
          className="bg-teal-600 h-full rounded-full transition-all duration-300"
          style={{ width: `${percent}%` }}
        />
      </div>
      {showPercent ? (
        <span className="text-xs text-gray-600 tabular-nums shrink-0">{percent}%</span>
      ) : null}
    </div>
  );
};

export default PurchaseOrderProgressBar;
